import React from 'react';
import Modal from 'react-modal';
import { formatDate, formatRupiah, formatTime } from '../../../helper/helper';
import { FaEnvelope, FaPrint } from 'react-icons/fa';
import WebsiteLogo from '../../WebsiteLogo';
import { useWebsiteSettings } from '../../../hooks/useWebsiteSettings';

const Invoice = ({ isOpen, closeInvoice, selectedItems, token }) => {
	const { settings } = useWebsiteSettings(token);
	return (
		<Modal
			isOpen={isOpen}
			onRequestClose={closeInvoice}
			contentLabel="Detail Modal"
			ariaHideApp={false}
			className="fixed w-full inset-0 flex items-center justify-center  md:p-8 p-4 bg-gray-500 bg-opacity-50"
			overlayClassName="fixed z-50 w-full  inset-0 bg-gray-800 bg-opacity-75"
		>
			{selectedItems && (
				<>
					<div id="print-area" className="w-full bg-white dark:bg-gray-800 lg:shadow-xl xl:shadow-xl dark:shadow-gray-900/50 print:transform print:scale-90 print:bg-white">
						<header className=" w-full flex flex-col items-center px-8 pt-8 text-lg text-center bg-white dark:bg-gray-800 border-t-8 border-primary dark:border-primary md:block lg:block xl:block print:block md:items-start lg:items-start xl:items-start print:items-start md:text-left lg:text-left xl:text-left print:text-left print:pt-0 print:px-2 md:relative lg:relative xl:relative print:relative print:bg-white print:dark:bg-white">
							<WebsiteLogo
								token={token}
								alt="Logo"
								className="w-3/6 h-auto md:w-1/4 lg:ml-12 xl:ml-12 print:px-0 print:py-0 object-contain object-left"
							/>
							<div className="flex flex-row mt-4 mb-2 ml-0 text-2xl font-bold text-gray-900 dark:text-gray-100 md:text-3xl lg:text-4xl xl:text-4xl print:text-2xl lg:ml-12 xl:ml-12 print:text-gray-900">
								INVOICE
								<div className="text-primary dark:text-primary-on-dark print:text-primary">
									<span className="mr-4 text-sm">■ </span> #
								</div>
								<span id="invoice_id" className="text-gray-500 dark:text-gray-400 print:text-gray-500">{selectedItems?.trxID}</span>
							</div>
							<div className="flex flex-col lg:ml-12 xl:ml-12 print:text-sm text-gray-800 dark:text-gray-200 print:text-gray-800">
								<span>Issue date: {formatDate(selectedItems?.createAt)}</span>
								<span>Paid date: -</span>
								<span>Due date: -</span>
							</div>
							<div className="px-8 py-2 mt-16 text-3xl font-bold text-primary dark:text-primary-on-dark border-4 border-primary dark:border-primary border-dotted md:absolute md:right-0 md:top-0 md:mr-12 lg:absolute lg:right-0 lg:top-0 xl:absolute xl:right-0 xl:top-0 print:absolute print:right-0 print:top-0 lg:mr-20 xl:mr-20 print:mr-2 print:mt-8 print:text-primary print:border-primary">UNPAID</div>
							<div className="flex flex-col m-12 text-center lg:m-12 md:flex-none md:text-left md:relative md:m-0 md:mt-16 lg:flex-none lg:text-left lg:relative xl:flex-none xl:text-left xl:relative print:flex-none print:text-left print:relative print:m-0 print:mt-6 print:text-sm text-gray-800 dark:text-gray-200 print:text-gray-800">
								<div className=" underline font-bold ">PAYMENT METHODS </div>
								<ul className=' ml-4'>
									<li className=' list-disc'>
										<div className=' font-semibold'>
											Transfer Bank
										</div>
										<div className=' '>
											<div>Bank Name : {selectedItems?.bank}</div>
											<div>Rekening Number : {selectedItems?.rekening_number}</div>
											<div>An. : {selectedItems?.owner}</div>
										</div>
									</li>
								</ul>

								<div className="flex flex-col md:absolute md:right-0 md:text-right lg:absolute lg:right-0 lg:text-right print:absolute print:right-0 print:text-right">
									<span className="  font-bold underline ">CUSTOMER </span>
									<span id="person-name" className="font-medium">{selectedItems?.customerName}</span>
									<span id="person-phone">{selectedItems?.customerPhone}</span>
									<span id="person-mail">{selectedItems?.customerEmail}</span>
									<span id="person-address">{selectedItems?.customerAddress}</span>

								</div>
							</div>
						</header>
						<hr className="border-gray-300 dark:border-gray-600 md:mt-8 print:border-gray-300" />

						<div>
							<div id="content" className="flex justify-center md:p-8 lg:p-20 xl:p-20 print:mt-8 print:p-2">
								<table className="w-full text-left table-auto print:text-sm" id="table-items">
									<thead>

										<tr className=" text-white bg-gray-700 dark:bg-gray-900 print:bg-primary print:text-black">
											<th className="border border-gray-600 dark:border-gray-500 print:border-gray-600 px-4 py-2">Item
											</th>
											<th className="border border-gray-600 dark:border-gray-500 print:border-gray-600 px-4 py-2 text-right">Qty</th>
											<th className=" border border-gray-600 dark:border-gray-500 print:border-gray-600 px-4 py-2 text-right">Unit Price</th>
										</tr>
									</thead>
									<tbody>

										<tr className="bg-gray-100 dark:bg-gray-700 print:bg-gray-100">
											<td className="px-4 py-2 border border-gray-300 dark:border-gray-600 print:border-gray-300 text-gray-800 dark:text-gray-200 print:text-gray-800">
												<div className=' print:font-semibold'>
													{selectedItems?.paymentName}
												</div>
												<div className="flex flex-col ml-4 text-xs ">
													<p className="flex items-center italic ">{selectedItems?.articleName}</p>

												</div>
											</td>
											<td className="px-4 py-2 text-right border border-gray-300 dark:border-gray-600 print:border-gray-300 tabular-nums slashed-zero text-gray-800 dark:text-gray-200 print:text-gray-800">1</td>
											<td className="px-4 py-2 text-right border border-gray-300 dark:border-gray-600 print:border-gray-300 tabular-nums slashed-zero print:w-28 text-gray-800 dark:text-gray-200 print:text-gray-800">Rp. {formatRupiah(selectedItems?.amount)}</td>
										</tr>

										<tr className="text-white bg-gray-700 dark:bg-gray-900 print:bg-gray-300 print:text-black" >
											<td className="px-4 py-2 font-extrabold text-right border border-gray-600 dark:border-gray-500 print:border-gray-600">Total</td>
											<td className="px-4 py-2 font-extrabold text-right border border-gray-600 dark:border-gray-500 print:border-gray-600">1</td>
											<td className="px-4 py-2 text-right border border-gray-600 dark:border-gray-500 print:border-gray-600 tabular-nums slashed-zero">Rp. {formatRupiah(selectedItems?.amount)}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>

						<footer className="flex flex-col items-center justify-center pb-20 leading-loose text-white bg-gray-700 dark:bg-gray-900 print:bg-white print:pb-0 print:text-gray-800">
							<span className="mt-4 text-xs print:mt-0">Invoice generated on {formatDate(selectedItems?.createAt)} {formatTime(selectedItems?.createAt)}</span>
							<span className="mt-4 text-base print:text-xs">{settings.footerText}</span>
						</footer>
					</div>
					<div className="w-full"></div>
					<div className=" print:hidden w-full space-x-4 flex justify-start">
						<button className="no-print w-full flex justify-center bg-white dark:bg-gray-700 space-x-2 items-center p-4 my-4 border-2 border-[#ffffff] dark:border-gray-600 text-primary dark:text-primary-on-dark text-2xl rounded hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors duration-200" title="Cetak" onClick={() => window.print()} > <FaPrint />  <span>Cetak</span></button>
						<button
							className="no-print w-full flex justify-center bg-white dark:bg-gray-700 space-x-2 items-center p-4 my-4 border-2 border-[#ffffff] dark:border-gray-600 text-primary dark:text-primary-on-dark text-2xl rounded hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors duration-200"
							title="Kirim Email"
						>
							<FaEnvelope />
						</button>
					</div>

				</>
			)}
		</Modal>
	);
};

export default Invoice;
